import { axiosInstance } from "libs/axiosInstance";
import axios from "axios";
import type { IPutImageToS3Params, TJob } from "./common.types";

export const putImagesToS3 = async ({ presignedPostUrlInfoList, fileList }: IPutImageToS3Params) => {
  const res = await axios.all(
    fileList.map(async (file, idx) => {
      return axios.put(presignedPostUrlInfoList[idx].presignedPostUrl, file);
    }),
  );
  return res;
};

export const getS3Images = async (imageKeys: string[], userId: string) => {
  const res = await axios.all(
    imageKeys.map(async (imageKey) => {
      return axiosInstance.get(`/my/user/${userId}/resource/worker/image/${imageKey}`);
    }),
  );
  return res;
};

export const postMultipartUploadImg = async (userId: string, image: File): Promise<{ image_key: string }> => {
  const formData = new FormData();
  formData.append("image", image);
  const res = await axiosInstance.post(`/my/user/${userId}/resource/worker/multipart`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

// ===== job ===== //
/** 분석 상황 조회 (query X) */
export const getJobInfo = async ({ jobId, userId }: { jobId: string; userId: string }) => {
  const res = await axiosInstance.get<TJob>(`/my/user/${userId}/analysis/job/${jobId}`);
  return res.data;
};
